import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "servicerapport-accordion-panel",
    templateUrl: "./servicerapport-accordion-panel.component.html",
    styleUrls: ["./servicerapport-accordion-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicerapportAccordionPanelComponent {
    @Input() public title: string;
    @Input() public empty = false;
    @Output() public opret = new EventEmitter();

    public onOpretClick(): void {
        this.opret.emit();
    }
}
